export const formatJobInfo = (user: { jobtitle?: string, company?: string } = {}): string => {
    const optionalAt = (user?.jobtitle && user?.company) ? ' @ ' : ''
    return (`${user?.jobtitle || ''}${optionalAt}${user?.company || ''}`)
}

export const formatName = (user: { first_name?: string, last_name?: string }): string => {
    const optionalSpace = (user?.first_name && user?.last_name) ? ' ' : ''
    return (`${user?.first_name || ''}${optionalSpace}${user?.last_name || ''}`)
}
